var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"cust-btn-color",on:{"click":_vm.onPrint}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" mdi-printer ")]),_vm._v(" "+_vm._s(_vm.$t('resultPayment.print'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }